import http from './http'

const basePath = '/achievement/paper'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function savePaper(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitPaper(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function updatePaper(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  const res = await http.put(basePath, body)
  return res.data
}

export async function getPaperById(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function deletePaper(id) {
  const res = await http.delete(withId(id))
  return res.data
}
